import EventEmitter from "wolfy87-eventemitter";
import { ISubscriberPlugin } from "../types";

export default class Subscriber extends EventEmitter
    implements ISubscriberPlugin {
    setup(): void {}
}
